import React from 'react';
import { FaStar } from 'react-icons/fa';

export default function StarRating({ label, value, onChange }) {
  return (
    <fieldset className="space-y-2">
      <legend className="text-sm font-medium text-gray-700">{label}</legend>

      <div className="flex space-x-1">
        {[1, 2, 3, 4, 5].map((n) => {
          const active = value >= n;
          return (
            <button
              key={n}
              type="button"
              onClick={() => onChange(n)}
              aria-label={`${n} star${n > 1 ? 's' : ''}`}
              className={`p-1 transition-transform ${
                active ? 'text-green-500' : 'text-gray-300'
              } hover:scale-110 focus:outline-none`}
            >
              <FaStar size={24} />
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
